import { Injectable } from "@angular/core"
import { DisplayDataResolver } from "@pl/pl-lib/common"
import { isEmpty } from "lodash"
import { Region } from "../../models/region"

@Injectable({
  providedIn: "root",
})
export class RegionDisplayDataResolver
  implements DisplayDataResolver<Region>
{
  typeDisplayName = "Region"

  constructor() {}

  getIcon(entity: Region): string | undefined {
    return "k-i-inherited"
  }

  getImage(entity: Region): string | undefined {
    return undefined
  }

  getSubTitle(entity: Region): string | undefined {
    return undefined
  }

  getTitle(entity: Region): string {
    return entity.name
  }

  getShortTitle(entity: Region): string {
    return entity.id
  }

  getItemHref(entityOrID: Region | string): string | undefined {
    if (isEmpty(entityOrID)) {
      return "/app/region"
    }
    if (typeof entityOrID === "string") return "/app/region/" + entityOrID
    return "/app/region/" + entityOrID.id
  }
}
